var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var AssetController = {
    /*****************************************************************************************************
        * Is using route "api/asset/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUri: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/list/{restrict?}" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {string} restrict
        * @returns {ExtendedDataCollection<AssetDownloadDto, string>}
    ******************************************************************************************************/
    GetAssets: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/list/{restrict?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {AssetDownloadDto}
    ******************************************************************************************************/
    GetAsset: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset" and http method "POST" to call the back-end.
    
        * @param {File} asset
        * @param {AssetUploadDto} data
        * @returns {AssetDownloadDto}
    ******************************************************************************************************/
    AddAsset: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.asset)
            fd.append("asset", data.asset);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteAsset: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/access/add/groups/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string[]} groupIds
        * @param {boolean} writeAccess
        * @returns {void}
    ******************************************************************************************************/
    AddGroupsAccess: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("groupIds", JSON.stringify(data.groupIds));
        fd.append("writeAccess", JSON.stringify(data.writeAccess));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/access/add/groups/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/access/add/users/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string[]} userIds
        * @param {boolean} writeAccess
        * @returns {void}
    ******************************************************************************************************/
    AddUsersAccess: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("userIds", JSON.stringify(data.userIds));
        fd.append("writeAccess", JSON.stringify(data.writeAccess));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/access/add/users/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/access/rem/groups/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string[]} groupIds
        * @returns {void}
    ******************************************************************************************************/
    RemoveGroupsAccess: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/access/rem/groups/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/asset/access/rem/users/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string[]} userIds
        * @returns {void}
    ******************************************************************************************************/
    RemoveUsersAccess: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("userIds", JSON.stringify(data.userIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/asset/access/rem/users/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=AssetController.js.map